const key = `QUESTIONNAIRE_TEMPLATE`

export const QUESTIONNAIRE_TEMPLATE = {
     CLEAR: `${key}_CLEAR`,
     SET_TEMPLATE_LIST_LOADING:`${key}_SET_TEMPLATE_LIST_LOADING`,
     SET_TEMPLATE_LIST:`${key}_SET_TEMPLATE_LIST`
};
